export enum OnboardingRegisterGuideStepStatus {
  NotStarted = 0,
  Skipped = 1,
  Next = 2,
  Completed = 10,
}
